import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { KNOWLEDGE } from "@/content/site";
import Reveal from "@/components/Reveal";
import ContextLine from "@/components/ContextLine";

export default function KnowledgePreview() {
  const featured = KNOWLEDGE.find((k) => k.featured) || KNOWLEDGE[0];
  const secondary = KNOWLEDGE.filter((k) => k.slug !== featured.slug).slice(0, 2);

  return (
    <section data-testid="knowledge-preview-section" className="bg-paper py-24 sm:py-32 border-t border-navy/10">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <Reveal>
            <span className="eyebrow mb-6">المعرفة</span>
            <h2 className="font-display text-navy leading-tight" style={{ fontSize: "clamp(1.5rem, 2.9vw, 2.5rem)" }}>
              نُنتج المعرفة ونشاركها.
            </h2>
          </Reveal>
          <Link to="/knowledge" className="link-underline text-navy font-medium" data-testid="knowledge-all-link">كل المعرفة</Link>
        </div>

        <div className="mt-14 grid gap-10 lg:grid-cols-[1.4fr_1fr]">
          {/* Short Siaq line linking the heading to the featured record */}
          <ContextLine d="M0,20 C120,4 220,36 360,20" viewBox="0 0 360 40" className="absolute -mt-8 h-8 w-40 pointer-events-none hidden lg:block" strokeWidth={2} />
          {/* Featured */}
          <Reveal>
            <Link to={`/knowledge/${featured.slug}`} data-testid={`knowledge-featured-${featured.slug}`} className="group block bg-navy text-white p-10 h-full" style={{ backgroundColor: "var(--navy)" }}>
              <span className="text-sm font-semibold" style={{ color: "var(--peach)" }}>{featured.type}</span>
              <h3 className="mt-4 font-display text-2xl sm:text-3xl leading-snug group-hover:text-peach transition-colors">{featured.title}</h3>
              <p className="mt-4 text-white/75 leading-relaxed">{featured.excerpt}</p>
              <span className="mt-8 inline-flex items-center gap-2 text-peach">اقرأ المزيد <ArrowLeft size={17} className="transition-transform group-hover:-translate-x-1" /></span>
            </Link>
          </Reveal>

          {/* Secondary */}
          <div className="flex flex-col gap-6">
            {secondary.map((k, i) => (
              <Reveal key={k.slug} delay={i * 0.1} className="flex-1">
                <Link to={`/knowledge/${k.slug}`} data-testid={`knowledge-item-${k.slug}`} className="group block border-t-2 pt-5 h-full" style={{ borderColor: "rgba(40,62,85,0.15)" }}>
                  <span className="text-sm font-semibold" style={{ color: "var(--purple)" }}>{k.type}</span>
                  <h3 className="mt-2 font-display text-navy text-xl leading-snug group-hover:text-coral transition-colors">{k.title}</h3>
                  <p className="mt-3 text-blue text-[0.95rem] leading-relaxed">{k.excerpt}</p>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
